export default __webpack_public_path__ + "static/media/b60.24c50e2a.png";